var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.758 11.828L18.607 3.979L20.021 5.393L18.607 6.808L21.081 9.282L19.667 10.697L17.192 8.222L15.778 9.636L17.899 11.757L16.485 13.172L14.364 11.05L12.172 13.242C12.8525 14.276 13.1254 15.5256 12.9379 16.7491C12.7505 17.9727 12.1161 19.0832 11.1573 19.8661C10.1985 20.649 8.98349 21.0486 7.74718 20.9876C6.51088 20.9267 5.34109 20.4094 4.46401 19.536C3.58504 18.6603 3.06304 17.4891 2.99946 16.25C2.93589 15.0109 3.33528 13.7925 4.12002 12.8314C4.90476 11.8704 6.01878 11.2354 7.24557 11.05C8.47236 10.8646 9.72428 11.1419 10.758 11.828ZM10.121 18.121C10.4123 17.8455 10.6454 17.5143 10.8066 17.1471C10.9677 16.7799 11.0536 16.3842 11.0592 15.9832C11.0648 15.5823 10.9899 15.1843 10.8391 14.8128C10.6882 14.4412 10.4644 14.1037 10.1808 13.8202C9.89728 13.5367 9.55977 13.3128 9.18825 13.162C8.81673 13.0111 8.41873 12.9362 8.01778 12.9418C7.61683 12.9474 7.22107 13.0333 6.85389 13.1944C6.48671 13.3556 6.15555 13.5887 5.88001 13.88C5.33353 14.4458 5.03115 15.2036 5.03799 15.9902C5.04482 16.7768 5.36033 17.5292 5.91655 18.0855C6.47278 18.6417 7.22521 18.9572 8.0118 18.964C8.79839 18.9709 9.5562 18.6685 10.122 18.122L10.121 18.121Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.f30ac78a59627106566f68cbe754c622.svg";
export { ForwardRef as ReactComponent };